import { i18n } from  'core/i18n';

import WizardError from 'components/commons/wizardError/wizardError';

import { taggingErrorStepRedirect } from '../../helpers/bringAccountTagging';

const { formatText, FormattedText } = i18n;

export const ErrorStep = ({ accountId, tealium }) => {
    const url = `/myprofile/accounts/${accountId}/movements`;

    return (
        <div className="transfer-account__error col-xs-offset-1 col-xs-10">
            <WizardError
                showTealium
                isSecondVersion
                tealium={tealium}
                errorMessage={formatText('transfer_account-transfer_account_from_another_bank_error_screen_title')}
                errorSubMessage={(
                    <div className="account-cancel-view__error-sub-message">
                        <FormattedText value="transfer_account-transfer_account_from_another_bank_error_screen_subtitle" />
                    </div>
                )}
                mainButton={{
                    label: formatText('transfer_account-transfer_account_from_another_bank_error_screen_button'),
                    url,
                }}
                doMainButtonCustomEvent={() => taggingErrorStepRedirect(url)}
            >
            </WizardError>
        </div>
    )
}
